import { useMemo, useState } from 'react';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import DataGridHeader from 'components/DataGrid/components/DataGridHeader';
import WithArrow from 'components/WithArrow';
import WithResize from 'components/WithResize';
import GridText from 'components/text/GridText';

import useGridTablesResizeObserver from 'hooks/useGridTablesResizeObserver';

import DataGridRow from './components/DataGridRow';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DataGrid: FunctionComponent<Props> = ({ className = '', rows = [], testId = TEST_ID }) => {
    const [openItems, setOpenItems] = useState<Record<number, boolean>>({});

    const toggleOpen = (id: number) => {
        setOpenItems(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const rootRows = useMemo(() => rows.filter(row => row.parentId === 0), [rows]);

    const { containerRef, handleResize } = useGridTablesResizeObserver('--data-grid-row-columns');

    return (
        <VerticalContainer
            className={`${className} ${styles.dataGrid}`}
            ref={containerRef}
            testId={testId}>
            <DataGridHeader>
                <WithResize onResize={handleResize}>
                    <WithArrow className={styles.withArrow}>
                        <GridText text='Name' />
                    </WithArrow>
                </WithResize>

                <WithResize onResize={handleResize}>
                    <GridText text='Last Edited' />
                </WithResize>

                <GridText text='Last Activity' />
            </DataGridHeader>

            {rootRows.map((row, index) => (
                <DataGridRow
                    allRows={rows}
                    key={row.id}
                    onToggleOpen={toggleOpen}
                    openItems={openItems}
                    parentId={row.parentId}
                    row={row}
                    rowIndex={index}
                />
            ))}
        </VerticalContainer>
    );
};

export default DataGrid;
